export interface BudgetCat {
  id: string;
  label: string;
  emoji: string;
  color: string;
  defaultBudget: number;
  plaidCategories: string[];
}

export interface Transaction {
  id: string;
  date: string;
  amount: number;
  category: string;
  merchant: string;
  source: "manual" | "plaid";
}

export const BUDGET_CATS: BudgetCat[] = [
  { id: "housing",       label: "Housing",       emoji: "🏠", color: "#0ea5e9", defaultBudget: 1000, plaidCategories: ["Rent", "Mortgage"] },
  { id: "food",          label: "Food",          emoji: "🍔", color: "#10b981", defaultBudget: 400,  plaidCategories: ["Food and Drink"] },
  { id: "transport",     label: "Transport",     emoji: "🚗", color: "#f59e0b", defaultBudget: 250,  plaidCategories: ["Transportation"] },
  { id: "entertainment", label: "Entertainment", emoji: "🎬", color: "#8b5cf6", defaultBudget: 150,  plaidCategories: ["Entertainment", "Recreation"] },
  { id: "savings",       label: "Savings",       emoji: "🏦", color: "#ec4899", defaultBudget: 300,  plaidCategories: ["Transfer", "Deposit"] },
  { id: "health",        label: "Health",        emoji: "💪", color: "#ef4444", defaultBudget: 100,  plaidCategories: ["Healthcare", "Health and Fitness"] },
  { id: "other",         label: "Other",         emoji: "📦", color: "#64748b", defaultBudget: 200,  plaidCategories: ["Shops", "Service", "Community"] },
];

export const EMPTY_BUDGET = {
  months: {} as Record<string, {
    income?: number;
    categories: Record<string, { budget: number }>;
    transactions: Transaction[];
  }>,
};

export function getMonthLabel(ym: string): string {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleString("default", { month: "long", year: "numeric" });
}

export function shiftMonth(ym: string, delta: number): string {
  const [y, m] = ym.split("-").map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return d.toISOString().slice(0, 7);
}

export function computeHealth(cats: Record<string, { budget: number; actual: number }>) {
  let totalBudget = 0, totalActual = 0;
  for (const v of Object.values(cats)) {
    totalBudget += v.budget;
    totalActual += v.actual;
  }
  const pct = totalBudget > 0 ? (totalActual / totalBudget) * 100 : 0;
  const status = pct > 100 ? "over" : pct >= 85 ? "close" : "good";
  return { totalBudget, totalActual, pct, status };
}
